module.exports = __webpack_public_path__ + "img/e_voucher_logo.05618013.svg";